import { render, staticRenderFns } from "./AccommodationCategoryForm.vue?vue&type=template&id=8990465e&"
import script from "./AccommodationCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AccommodationCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccommodationCategoryForm.vue"
export default component.exports